export default {
  methods: {
    changeFormBind(bindForms, item, value) {
      if (item.id === 'timeType') {
        const chooseChild = item.children.find(elem => elem.id === value)
        this.formArr = this.formArr.map(item => {
          if (item.id === chooseChild.showItemId) item.isHide = false
          if (item.id === chooseChild.hideItemId) item.isHide = true
          return item
        })
        // 如果是月份则重新定义
        if (value * 1 === 0) {
          const year = bindForms.dateMonth.substr(0, 4)
          const month = bindForms.dateMonth.substr(5, 7)
          // 本月的结束时间
          const monthEndDate = new Date(year, month, 0).getDate()
          bindForms['dateTimeStartTime'] = bindForms.dateMonth + '-01'
          bindForms['dateTimeEndTime'] = bindForms.dateMonth + '-' + monthEndDate
        }
      } else if (item.id === 'dateMonth' && bindForms.dateMonth) {
        const year = bindForms.dateMonth.substr(0, 4)
        const month = bindForms.dateMonth.substr(5, 7)
        // 本月的结束时间
        const monthEndDate = new Date(year, month, 0).getDate()
        bindForms['dateTimeStartTime'] = bindForms.dateMonth + '-01'
        bindForms['dateTimeEndTime'] = bindForms.dateMonth + '-' + monthEndDate
      }
      this.bindForms = bindForms
      // 缓存参数
      const platParam = {
        brand: bindForms.brand || '',
        platform: bindForms.platform,
        lineName: bindForms.lineName,
        timeType: bindForms.timeType,
        dateMonth: bindForms.dateMonth,
        dateTimeStartTime: bindForms.dateTimeStartTime,
        dateTimeEndTime: bindForms.dateTimeEndTime,
        isPrereport: bindForms.isPrereport
      }
      if (!platParam.brand) delete platParam.brand
      if (!platParam.platform) delete platParam.platform
      this.$store.dispatch('setPlatParam', platParam)
      this.pageTotalAjax && this.pageTotalAjax(bindForms, item, value)
    },
    // 获取当前所有参数
    getParam() {
      const bindForms = JSON.parse(JSON.stringify(this.bindForms))
      // 则选择的是月
      bindForms.time = {
        startTime: bindForms.dateTimeStartTime || '',
        endTime: bindForms.dateTimeEndTime || ''
      }
      delete bindForms.dateMonth
      delete bindForms.dateTimeEndTime
      delete bindForms.dateTimeStartTime
      delete bindForms.dateTime
      return bindForms
    },
    // 折线图参数单独时间处理
    paramTimeHandle(param) {
      // 时间修改
      if (param.time.endTime) {
        // 声量趋势模块日期重新处理
        const endTime = param.time.endTime
        const times = endTime.split('-')
        if (param.timeType * 1 === 1) {
          // 如果是日报的时候，则介绍时间向前推一年
          param.time.startTime = [times[0] - 1, times[1], times[2]].join('-')
          // // 如果是日报的时候，则介绍时间向前推30天
          // const lastMonthEndDate = new Date(times[0], times[1] - 1, 0).getDate()
          // if (times[1] * 1 === 1) { // 如果当前是1月份
          //   param.time.startTime = [times[0] - 1, '12', 31].join('-')
          // } else {
          //   param.time.startTime = [times[0], times[1] * 1 - 1, lastMonthEndDate].join('-')
          // }
        } else {
          // 如果是月报的时候，则介绍时间向前推一年
          param.time.startTime = [times[0] - 1, times[1], times[2]].join('-')
        }
      }
      return param
    },
    // 刷新列表
    refreshList() {
      // 获取表格数据
      this.getList()
      // 获取表格数据总数
      this.getListTotal()
    },
    // 页数改变
    sizeChange(pageSize) {
      this.getList(1, pageSize)
    },
    // 当前页数改变
    currentChange(currentPage) {
      this.getList(currentPage)
    }
  }
}
